import { consoleLogger } from '@shared/logging/consoleLogger';
import {
  UtiqAskMeLater,
  UtiqOpenRtbEidsEntryName,
} from '@shared/constants/utiq';

const defaultIdConnectDataStorageValue = 'utiqPass';
const dataCallTimeStorageValue = 'utiqDataCallTimestamp';

export const clearStorageData = () => {
  let storageType = localStorage;
  if (
    typeof window.IDCONNECT_CONFIG?.IDCONNECT_STORAGE_TYPE === 'string' &&
    window.IDCONNECT_CONFIG.IDCONNECT_STORAGE_TYPE === 'sessionStorage'
  ) {
    storageType = sessionStorage;
  }

  /* If IDCONNECT_CONFIG was not yet initialised, we use the static key names to clear localStorage data */
  const idConnectDataStorageKey = window.IDCONNECT_CONFIG
    ?.IDCONNECT_DATA_STORAGE
    ? window.IDCONNECT_CONFIG.IDCONNECT_DATA_STORAGE
    : defaultIdConnectDataStorageValue;

  /* Clear utiqPass (unless named differently in config) data from the storage */
  if (typeof idConnectDataStorageKey === 'string') {
    if (storageType.getItem(idConnectDataStorageKey) !== null) {
      storageType.removeItem(idConnectDataStorageKey);
    }
  }

  /* Clear utiqDataCallTimestamp local storage data, that blocks the data call until the interval passes */
  if (localStorage.getItem(dataCallTimeStorageValue) !== null) {
    localStorage.removeItem(dataCallTimeStorageValue);
  }

  /* Clear UtiqAskMeLater data */
  if (localStorage.getItem(UtiqAskMeLater) !== null) {
    localStorage.removeItem(UtiqAskMeLater);
  }

  if (sessionStorage.getItem(UtiqAskMeLater)) {
    sessionStorage.removeItem(UtiqAskMeLater);
  }

  /* Clear GAM localStorage flag, that enabled/disables utiq as Google secure signal provider */
  const utiqGAMProviderKey = '_GESPSK-utiq.com';
  if (localStorage.getItem(utiqGAMProviderKey) !== null) {
    localStorage.removeItem(utiqGAMProviderKey);
  }

  /* Clear netid_utiq_adtechpass local storage data */
  if (localStorage.getItem(UtiqOpenRtbEidsEntryName) !== null) {
    localStorage.removeItem(UtiqOpenRtbEidsEntryName);
  }

  consoleLogger.logDebug('Cleared IDConnect data from storage');
};
